import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

// Estilos
const Container = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 60px;
  background-color: #f9f9f9;
  border-radius: 20px;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.1);
  text-align: center;
  min-height: calc(100vh - 120px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media (max-width: 768px) {
    padding: 20px;
  }
`;

const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: bold;
  color: #101828;
  margin-bottom: 20px;
`;

const SubTitle = styled.h2`
  font-size: 1.5rem;
  color: #555;
  margin-bottom: 40px;
`;

const PlansContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

const PlanCard = styled.div`
  flex: 1;
  padding: 40px;
  background-color: ${(props) => (props.highlighted ? "#f0f8ff" : "#fff")};
  border: 2px solid ${(props) => (props.highlighted ? "#0044cc" : "#ddd")};
  border-radius: 10px;
  box-shadow: ${(props) =>
    props.highlighted
      ? "0px 8px 25px rgba(0, 68, 204, 0.2)"
      : "0px 4px 15px rgba(0, 0, 0, 0.1)"};
  text-align: center;
  transition: transform 0.3s ease;
  &:hover {
    transform: scale(1.05);
  }
`;

const PlanTitle = styled.h3`
  font-size: 1.8rem;
  font-weight: bold;
  color: #101828;
  margin-bottom: 15px;
`;

const PlanPrice = styled.p`
  font-size: 1.5rem;
  color: #0044cc;
  font-weight: bold;
  margin: 15px 0;
`;

const FeatureList = styled.ul`
  text-align: left;
  padding: 0;
  list-style: none;
  color: #555;
`;

const FeatureItem = styled.li`
  margin-bottom: 10px;
  font-size: 1rem;
  display: flex;
  align-items: center;
  gap: 10px;
  &:before {
    content: "✔";
    color: #0044cc;
  }
`;

const CTAButton = styled.button`
  background-color: ${(props) => (props.highlighted ? "#0044cc" : "#151c48")};
  color: #fff;
  font-size: 1.2rem;
  padding: 15px 30px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;

  &:hover {
    background-color: ${(props) => (props.highlighted ? "#0033a0" : "#0f1733")};
  }

  &:active {
    transform: scale(0.98);
  }
`;

function SubscriptionPlans() {
  const navigate = useNavigate();

  return (
    <Container>
      <Title>Escolha seu Plano</Title>
      <SubTitle>Planos flexíveis para atender às suas necessidades.</SubTitle>
      <PlansContainer>
        <PlanCard>
          <PlanTitle>Plano Free</PlanTitle>
          <PlanPrice>Gratuito</PlanPrice>
          <FeatureList>
            <FeatureItem>Visibilidade limitada nos resultados</FeatureItem>
            <FeatureItem>Acesso restrito a leads</FeatureItem>
            <FeatureItem>Funcionalidades básicas do sistema</FeatureItem>
          </FeatureList>
          <CTAButton onClick={() => navigate("/login")}>Começar Agora</CTAButton>
        </PlanCard>

        <PlanCard highlighted>
          <PlanTitle>Plano Profissional</PlanTitle>
          <PlanPrice>€ 59/mês</PlanPrice>
          <FeatureList>
            <FeatureItem>Visibilidade premium e destaque nos resultados</FeatureItem>
            <FeatureItem>Acesso total a leads e informações completas</FeatureItem>
            <FeatureItem>Dashboard com métricas avançadas</FeatureItem>
            <FeatureItem>Kanban para gerenciar clientes e tarefas</FeatureItem>
            <FeatureItem>Relatórios detalhados para otimizar o desempenho</FeatureItem>
          </FeatureList>
          <CTAButton highlighted onClick={() => navigate("/checkout-profissional")}>
            Assinar Agora
          </CTAButton>
        </PlanCard>
      </PlansContainer>
    </Container>
  );
}

export default SubscriptionPlans;
